export const getContextOutcome = (response) => {
  if (!response) return { code: 'unknown', message: null };
  if ((response.objects || []).length > 0) {
    return { code: 'available', message: null };
  }
  if (response.totalMatched > 0) {
    return {
      code: 'not-available-now',
      message: 'Nothing from this LifeCode is available to you right now.',
    };
  }
  return {
    code: 'no-context',
    message: 'Nothing is attached to this LifeCode yet.',
  };
};

export const hasResolvedLifeCode = (response) =>
  Boolean(response?.contextSnapshot?.resolvedAnchorIds?.length);
